import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios"
import * as qs from "qs"
import { Config, DefaultHeaders } from "./types/request"

export class HttpBase {
  public host: string

  constructor(host: string) {
    this.host = host
  }

  public async get(path: string, config?: Config): Promise<AxiosResponse> {
    return this.http.get(path, { ...config })
  }

  public async post(
    path: string,
    body: any,
    config?: Config
  ): Promise<AxiosResponse> {
    return this.http.post(path, body, { ...config })
  }

  public async patch(
    path: string,
    body: any,
    config?: Config
  ): Promise<AxiosResponse> {
    return this.http.patch(path, body, { ...config })
  }

  public async delete(path: string, config?: Config): Promise<AxiosResponse> {
    return this.http.delete(path, { ...config })
  }

  public async request(config: AxiosRequestConfig): Promise<AxiosResponse> {
    return axios({ ...config, url: `${this.host}${config.url}` })
  }

  get headers() {
    const headers: Partial<DefaultHeaders> = {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    }

    return headers
  }

  get http(): AxiosInstance {
    const http = axios.create({
      baseURL: this.host,
      headers: this.headers,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "brackets" })
      },
    })

    return http
  }
}
